import { Box, Column, Row, Text } from '@atom-web/micros'
import { result } from 'lodash'
import dynamic from 'next/dynamic'

import ContentWrapper from '../../components/ContentWrapper'
import DisplayPrice from '../../components/DisplayPrice'
import capitializeFirstChar from '../capitializeFirstChar'
import clearImagePath from '../clearImagePath'
import flatMap from '../lodashUtils/flatMap'
import get from '../lodashUtils/get'
import getStrapiMediaData from './getStrapiMediaData'

const CardSliderNew = dynamic(() =>
	import('../../features/destination/components/cardSlider'),
)
const PageDescription = dynamic(() =>
	import('../../features/destination/components/pageDescription'),
)
const ThinksToDo = dynamic(() =>
	import('../../features/destination/components/thingsToDo'),
)

// Card components
const InterlinkingCard = dynamic(() =>
	import('../../features/destination/components/interlinkingSmallCard'),
)
const ItinerariesCardComponent = dynamic(() =>
	import('../../features/destination/components/ItinerariesCardComponent'),
)
// const DesignationCard = dynamic(() =>
// 	import('../../features/destination/components/DestinationGuideCard'),
// )

const ActivityDescription = dynamic(() =>
	import('../../features/destination/components/ActivityDescription'),
)
const ActivityInclusion = dynamic(() =>
	import('../../features/destination/components/ActivityInclusionlist'),
)
const FAQ = dynamic(() => import('../../features/destination/components/FAQ'))
const PillList = dynamic(() => import('../../components/PillList'))

//
const PartnersLogo = dynamic(() =>
	import('../../components/partners/PartnersLogo'),
)
const Inclusion = dynamic(() => import('../../components/partners/inclusion'))
const PlanVacation = dynamic(() =>
	import('../../components/partners/planVacation'),
)
const MediaComponent = dynamic(() =>
	import('../../components/partners/MediaComponent'),
)
const ScapiaCard = dynamic(() => import('../../components/scapiaCard'))
// const MediaComponent = dynamic(() =>
// 	import('../../components/partners/MediaComponent'),
// )

const EmiValueAddsComponent = dynamic(() =>
	import('../../components/EmiValueAddsComponent'),
)

const getProductListingData = ({ targetKey, data }) => {
	if (!data) return []

	let matchedObject = {}
	switch (targetKey) {
		case 'departure-cities':
			matchedObject = data.find(a => a.categoryName === 'DEPARTURE_CITY')
			break
		case 'by-cities':
			matchedObject = data.find(a => a.categoryName === 'INTERLINKED_CITY')
			break
		case 'themes':
			matchedObject = data.find(a => a.categoryName === 'THEME')
			break
		default:
			matchedObject = data.find(a => a.categoryName === 'OTHER_DESTINATION')
			break
	}

	return matchedObject?.interlinkedPageDetails
}

const getStrapiRelationalData = ({ target, data }) => {
	if (!data) return []

	// countries.regions
	// countries
	// regions
	// cities
	// things_to_dos
	// attractions

	let matchedObject = {}
	switch (target) {
		case 'countries.regions':
			matchedObject = [
				...get(data, 'countries.data', []),
				...get(data, 'regions.data', []),
			]
			break
		case 'countries':
			matchedObject = [...get(data, 'countries.data', [])]
			break
		case 'regions':
			matchedObject = [...get(data, 'regions.data', [])]
			break
		case 'cities':
			matchedObject = [...get(data, 'cities.data', [])]
			break
		case 'things_to_dos':
			matchedObject = [...get(data, 'things_to_dos.data', [])]
			break
		case 'attractions':
			matchedObject = [...get(data, 'attractions.data', [])]
			break
		case 'activities':
			matchedObject = [...get(data, 'activities.data', [])]
			break
		case 'activity_details':
			matchedObject = [...get(data, 'activity_details.data', [])]
			break
		case 'best_time_to_visits':
			matchedObject = [...get(data, 'best_time_to_visits.data', [])]
			break
		case 'guides':
			matchedObject = [...get(data, 'guides.data', [])]
			break
		case 'how_to_reaches':
			matchedObject = [...get(data, 'how_to_reaches.data', [])]
			break
		case 'journeys':
			matchedObject = [...get(data, 'journeys.data', [])]
			break
		case 'places_to_visits':
			matchedObject = [...get(data, 'places_to_visits.data', [])]
			break
		case 'visa_guidelines':
			matchedObject = [...get(data, 'visa_guidelines.data', [])]
			break
		default:
			matchedObject = []
			break
	}

	return matchedObject
}

const getPageDataComponents = ({
	item,
	index,
	productPackagesListingData,
	productInterlinkingData,
	staticData,
	pageLayoutCondition,
	partnersPage,
	FaqDefaultOpen,
	slug,
	resort,
}) => {
	let componentData = item?.data
	switch (item.__component) {
		case 'widgets.slider-for-wider-cards':
		case 'widgets.slider-for-small-cards': {
			const widerCardConfig = {
				360: {
					slidesPerView: 'auto',
					spaceBetween: 24,
					freeMode: true,
				},
				1024: {
					slidesPerView: resort ? 2.5 : pageLayoutCondition ? 2.7 : 4,
					slidesPerGroup: resort ? 2 : pageLayoutCondition ? 2 : 4,
					spaceBetween: 24,
					freeMode: false,
				},
			}

			const smallCardConfig = {
				360: {
					slidesPerView: 'auto',
					spaceBetween: 24,
					freeMode: true,
				},
				1024: {
					slidesPerView: resort ? 3.5 : pageLayoutCondition ? 4 : 6,
					slidesPerGroup: pageLayoutCondition ? 4 : 6,
					spaceBetween: 24,
					freeMode: false,
				},
			}

			const sliderConfig = {
				breakpoints: {
					...(item.__component === 'widgets.slider-for-wider-cards'
						? widerCardConfig
						: smallCardConfig),
				},
			}

			if (partnersPage) {
				componentData = componentData?.map(a => {
					const imageObj = getStrapiMediaData(a?.image)
					return {
						...a,
						image: imageObj?.url,
						alt: imageObj?.alt,
						slug: '#',
						title: capitializeFirstChar(a?.title),
					}
				})
			} else if (!componentData?.length) {
				if (item?.productInterlinkingQuery) {
					const data = getProductListingData({
						targetKey: item?.productInterlinkingQuery,
						data: get(
							productPackagesListingData,
							'campaignDetails.interlinkingBlocks',
						),
					})

					componentData = data?.map(a => {
						const priceData = (
							<DisplayPrice
								objectData={{ value: a?.tripStartingPrice }}
								path={'value'}
								defaultValue="0"
							/>
						)

						return {
							image: clearImagePath(a?.image, 'images'),
							slug: `/${a?.key}`,
							title: capitializeFirstChar(a?.name),
							description: <>From {priceData}/Person</>,
						}
					})
				} else if (item?.strapiRelationalDataQuery) {
					const data = getStrapiRelationalData({
						target: item?.strapiRelationalDataQuery,
						data: staticData,
					})

					componentData = data?.map(a => {
						const item = a?.attributes

						const imageObj = getStrapiMediaData(
							get(item, 'bannerMedia.bannerImage'),
						)

						return {
							image: get(imageObj, 'url'),
							alt: get(imageObj, 'alt'),
							slug: `/${item?.slug}`,
							title: capitializeFirstChar(get(item, 'bannerTitle.title')),
							description: get(item, 'bannerTitle.subTitle'),
						}
					})
				}
			} else {
				componentData = componentData?.map(a => {
					const imageObj = getStrapiMediaData(a?.image)

					return {
						...a,
						image: imageObj?.url,
						alt: imageObj?.alt,
						title: capitializeFirstChar(a?.title),
					}
				})
			}
			return (
				<>
					{partnersPage ? (
						<ContentWrapper
							css={{
								marginTop: '56px',
							}}
						>
							<CardSliderNew
								componentData={item}
								sliderConfig={sliderConfig}
								index={index}
								partnersPage={partnersPage}
								cardLength={componentData?.length}
								resort={resort}
							>
								{componentData?.map((cardData, inx) => (
									<InterlinkingCard
										componentData={cardData}
										height={'136px'}
										width={
											item?.__component === 'widgets.slider-for-small-cards'
												? '172px'
												: '270px'
										}
										// width={'172px'}
										componentName={item?.__component}
										index={index}
										key={`${item.__component}_${index}_${inx}`}
									/>
								))}
							</CardSliderNew>
						</ContentWrapper>
					) : (
						<CardSliderNew
							componentData={item}
							sliderConfig={sliderConfig}
							index={index}
							partnersPage={partnersPage}
							cardLength={componentData?.length}
							resort={resort}
						>
							{componentData?.map((cardData, inx) => (
								<InterlinkingCard
									componentData={cardData}
									height={'136px'}
									width={
										item?.__component === 'widgets.slider-for-small-cards'
											? '172px'
											: '270px'
									}
									// width={'172px'}
									componentName={item?.__component}
									index={index}
									key={`${item.__component}_${index}_${inx}`}
								/>
							))}
						</CardSliderNew>
					)}
				</>
			)
		}
		case 'widgets.slider-for-itineraries': {
			const sliderConfig = {
				breakpoints: {
					360: {
						slidesPerView: 'auto',
						spaceBetween: 24,
						freeMode: true,
					},
					1024: {
						slidesPerView: pageLayoutCondition ? 2.5 : 4,
						slidesPerGroup: pageLayoutCondition ? 2 : 4,
						spaceBetween: pageLayoutCondition ? 10 : 24,
					},
				},
			}

			if (!componentData?.length) {
				if (item?.productInterlinkingTags) {
					const data =
						productInterlinkingData?.data?.[item?.productInterlinkingTags]

					componentData = data?.map(a => {
						const priceData = (
							<DisplayPrice
								objectData={{ value: a?.itineraryCost }}
								path={'value'}
								defaultValue="0"
							/>
						)

						const inclusions = []
						if (a?.flightsIncluded) {
							inclusions.push('Flights')
						}

						if (a?.hotelsIncluded) {
							inclusions.push('Hotels')
						}

						if (a?.activities?.length > 0) {
							inclusions.push('Activities')
						}

						if (a?.transferIncluded) {
							inclusions.push('Transfers')
						}
						return {
							image: clearImagePath(a?.image, 'images'),
							slug: `/${a?.slug}`,
							title: capitializeFirstChar(a?.title),
							price: <>{priceData}</>,
							priceLabel: `${a?.totalPAX} Person . ${a?.nights} nights`,
							inclusions,
							// offerPercentage: 20
						}
					})
				}
			}
			return (
				<CardSliderNew
					componentData={item}
					sliderConfig={sliderConfig}
					index={index}
					cardLength={componentData?.length}
				>
					{componentData?.map((cardData, inx) => (
						<ItinerariesCardComponent
							componentData={cardData}
							key={`${item.__component}_${index}_${inx}`}
							packagesItinerary={true}
						/>
					))}
				</CardSliderNew>
			)
		}
		// case 'widgets.slider-for-acitvity': {
		// 	return (
		// 		<CardSliderNew componentData={item} index={index}>
		// 			<ItinerariesCardComponent componentData={item} activitycard={true} />
		// 		</CardSliderNew>
		// 	)
		// }
		// case 'widgets.slider-for-guides-card': {
		// 	return (
		// 		<CardSliderNew componentData={item} index={index}>
		// 			<DesignationCard componentData={item} />
		// 		</CardSliderNew>
		// 	)
		// }
		case 'widgets.slider-for-scapia-card': {
			const widerCardConfig = {
				360: {
					slidesPerView: 'auto',
					spaceBetween: 24,
					freeMode: true,
				},
				1024: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					spaceBetween: 24,
					freeMode: false,
				},
			}
			const sliderConfig = {
				breakpoints: {
					...widerCardConfig,
				},
			}
			return (
				<ContentWrapper
					css={{
						marginTop: '56px',
					}}
				>
					<CardSliderNew
						componentData={item}
						sliderConfig={sliderConfig}
						index={index}
						partnersPage={partnersPage}
						cardLength={item?.cards?.length}
					>
						{item?.cards?.map((cardData, inx) => {
							const img = getStrapiMediaData(cardData?.image).rawData
							return (
								<ScapiaCard cardData={cardData} key={inx} image={img.url} />
							)
						})}
					</CardSliderNew>
				</ContentWrapper>
			)
		}
		case 'widgets.banner-about-component': {
			if (item) {
				return (
					<PageDescription
						componentData={item}
						pageLayoutCondition={pageLayoutCondition}
					/>
				)
			}
			return null
		}
		case 'widgets.description-section': {
			return <ActivityDescription data={item} />
		}
		case 'widgets.inclusions-list': {
			return <ActivityInclusion data={item} />
		}
		case 'widgets.faq': {
			return <FAQ componentData={item} FaqDefaultOpen={FaqDefaultOpen} />
		}
		case 'widgets.interlinking-pills': {
			return <PillList content={item.pills} item={item.title} />
		}
		case 'widgets.things-to-do': {
			return <ThinksToDo data={item} index={index} />
		}
		case 'widgets.partners-logo': {
			return <PartnersLogo data={item} />
		}
		case 'widgets.inclusions': {
			return <Inclusion data={item} />
		}
		case 'widgets.plan-vacation': {
			return <PlanVacation data={item} slug={slug} />
		}
		case 'widgets.card-listing': {
			if (item?.RelationName === 'journeys') {
				const journeysdata = getStrapiRelationalData({
					target: item?.RelationName,
					data: staticData,
				})

				if (journeysdata?.length > 0) {
					const data = journeysdata

					componentData = data?.map(a => {
						let dayCounts = null
						const priceData = (
							<DisplayPrice
								objectData={{ value: a?.attributes?.totalAmount }}
								path={'value'}
								defaultValue="0"
							/>
						)

						const inclusions = []
						if (a?.attributes?.dayWisePlan) {
							a?.attributes?.dayWisePlan?.forEach(p => {
								p?.hotelId && !inclusions?.includes('Hotels')
									? inclusions.push('Hotels')
									: null
							})
						}

						if (a?.attributes?.dayWisePlan) {
							a?.attributes?.dayWisePlan?.forEach(p => {
								if (p?.days.length > 0) {
									dayCounts++
								}
								p?.days?.forEach(q => {
									q?.slots?.forEach(r => {
										r?.slotType === 'ACTIVITY' &&
										!inclusions?.includes('Activities')
											? inclusions.push('Activities')
											: null
									})
								})
							})
						}

						if (a?.attributes?.transfers.length > 0) {
							inclusions.push('Transfers')
						}

						return {
							image: clearImagePath(
								a?.attributes?.bannerImage?.[0]?.bannerImage?.data?.attributes
									?.url,
								'',
							),
							slug: `/journeys/${a?.attributes?.slug}`,
							title: capitializeFirstChar(
								a?.attributes?.pageDescription?.title,
							),
							price: <>{priceData}</>,
							priceLabel: `${a?.attributes?.paxConfig} Person . ${
								dayCounts - 1
							} nights`,
							inclusions,
						}
					})
				}
				return (
					<Column
						css={{
							gap: 12,
							'@lg': {
								gap: 18,
							},
						}}
					>
						<Text
							css={{
								fontSize: '$5',
								fontWeight: '$bold',
								lineHeight: '$4',
								color: '$grey12',
								'@lg': {
									fontSize: '$6',
									lineHeight: '$5',
								},
								paddingBottom: '$3',
							}}
						>
							{item?.title}
						</Text>
						<Row
							css={{
								flexWrap: 'wrap',
								gap: '$4',
								'@lg': {
									gap: '$6',
								},
							}}
						>
							{componentData?.map((cardData, inx) => (
								<ItinerariesCardComponent
									componentData={cardData}
									key={`${item.__component}_${index}_${inx}`}
									packagesItinerary={true}
								/>
							))}
						</Row>
					</Column>
				)
			}
			//
			else {
				let data = []
				item?.RelatedItems?.forEach(p => {
					let rData = getStrapiRelationalData({
						target: p,
						data: staticData,
					})
					data = [...data, ...rData]
				})

				componentData = data?.map(a => {
					const item = a?.attributes

					const imageObj = getStrapiMediaData(
						get(item, 'bannerMedia.bannerImage'),
					)

					return {
						image: get(imageObj, 'url'),
						alt: get(imageObj, 'alt'),
						slug: `/${item?.slug}`,
						title: capitializeFirstChar(get(item, 'bannerTitle.title')),
						description: get(item, 'bannerTitle.subTitle'),
					}
				})
				return (
					<Column
						css={{
							gap: 12,
							'@lg': {
								gap: 18,
							},
						}}
					>
						<Text
							css={{
								fontSize: '$5',
								fontWeight: '$bold',
								lineHeight: '$4',
								color: '$grey12',
								'@lg': {
									fontSize: '$6',
									lineHeight: '$5',
								},
								paddingBottom: '$3',
							}}
						>
							{item?.title}
						</Text>
						<Row
							css={{
								flexWrap: 'wrap',
								gap: '$4',
								'@lg': {
									gap: '$6',
								},
							}}
						>
							{componentData?.map((cardData, inx) => (
								<InterlinkingCard
									componentData={cardData}
									height={'136px'}
									width={'170px'}
									componentName={item?.__component}
									index={index}
									key={`${item.__component}_${index}_${inx}`}
								/>
							))}
						</Row>
					</Column>
				)
			}
		}
		case 'widgets.one-column-media': {
			return <MediaComponent cardData={item} layoutCount={1} />
		}
		case 'widgets.value-adds-widget': {
			if (item.isSlider !== true) {
				return null
			}

			const smallCardConfig = {
				360: {
					slidesPerView: 1,
					slidesPerGroup: 1,
					freeMode: false,
				},
				1024: {
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 0,
					freeMode: false,
				},
			}

			const sliderConfig = {
				breakpoints: {
					...smallCardConfig,
				},
			}

			return (
				<CardSliderNew
					componentData={item?.values}
					sliderConfig={sliderConfig}
					index={index}
					pagination={true}
					isShowButton={false}
					autoplay={true}
					swiperCss={
						{
							// borderRadius: 12,
							// border: '1px solid $s_custom51',
							// background: '$s_custom52',
							// paddingBottom: '50px'
						}
					}
					transParentBackGround={true}
					cardLength={item?.values?.length}
				>
					{item?.values?.map((cardData, inx) => (
						<EmiValueAddsComponent
							componentData={cardData}
							key={`${item.__component}_${index}_${inx}`}
						/>
					))}
				</CardSliderNew>
			)
		}
		default:
			return null
	}
}

export default getPageDataComponents
